import React from "react"
import styled from "styled-components"

import BabyShower from "../images/DS_babyshower.jpeg"
import Baptism from "../images/DS_baptism.jpg"
import BirthdayAdult from "../images/DS_birthday_adult.jpg"

import BirthdayKid from "../images/DS_birthday_kid.jpg"
import BirthdayDebut from "../images/DS_birthday_debut.jpeg"
import Wedding from "../images/DS_wedding.jpg"

import Anniversary from "../images/DS_anniversary.jpeg"
import HouseWarming from "../images/DS_housewarming.jpg"
import Others from "../images/DS_others.jpg"
import { navigate } from "gatsby"
import { BASE_URL } from "../helpers/constants"

const MainBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  margin-bottom: 0rem;
  margin-top: 1.4rem;
  padding: 0 0.6rem;
  @media (min-width: 768px) {
    padding: 0 0.8rem;
  }
`

const TabBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  max-width: 130rem;
  flex-wrap: wrap;
`

const TabItemBox = styled.div`
  user-select: none;
  position: relative;
  display: flex;
  width: 47%;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 0.8rem 0;
  @media (min-width: 768px) {
    width: 48%;
  }
  @media (min-width: 961px) {
    width: 31%;
    margin: 1.2rem 0;
  }
  &:hover {
    box-shadow: 0 0.2rem 0.4rem rgb(0, 0, 0, 0.2);
  }
`

const Image = styled.img`
  display: block;
  width: 100%;
  height: auto;
`

const ImageTextOverlay = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100%;
  opacity: 0.2;
  background-color: #000;
  color: #fff;
  ${TabItemBox}:hover & {
    opacity: 1;
    background-color: transparent;
  }
`

const ImageText = styled.div`
  user-select: none;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  /* font-size: 2.4rem; */
  font-size: 1.8rem;
  height: 100%;
  color: #fff;
  font-style: italic;
  ${TabItemBox}:hover & {
    display: none;
  }
  @media (min-width: 768px) {
    font-size: 2.2rem;
  }
`

const Anchor = styled.a`
  text-decoration: none;
`

const EventWidget = () => {
  return (
    <MainBox>
      <TabBox>
        <TabItemBox key={"babyshower"}>
          <Image src={BabyShower} />
          <Anchor
            href={`${BASE_URL}/products/Baby%20Shower`}
            onClick={event => {
              event.preventDefault()
              navigate(`/products/Baby%20Shower`)
            }}
          >
            <ImageTextOverlay />
          </Anchor>
          <ImageText>Baby Shower</ImageText>
        </TabItemBox>

        <TabItemBox key={"baptism"}>
          <Image src={Baptism} />
          <Anchor
            href={`${BASE_URL}/products/Baptism`}
            onClick={event => {
              event.preventDefault()
              navigate(`/products/Baptism`)
            }}
          >
            <ImageTextOverlay />
          </Anchor>
          <ImageText>Baptism</ImageText>
        </TabItemBox>
        <TabItemBox key={"birthdayadult"}>
          <Image src={BirthdayAdult} />
          <Anchor
            href={`${BASE_URL}/products/Birthday-Adult`}
            onClick={event => {
              event.preventDefault()
              navigate(`/products/Birthday-Adult`)
            }}
          >
            <ImageTextOverlay />
          </Anchor>
          <ImageText>Birthday-Adult</ImageText>
        </TabItemBox>

        <TabItemBox key={"birthdaykids"}>
          <Image src={BirthdayKid} />
          <Anchor
            href={`${BASE_URL}/products/Birthday-Kids`}
            onClick={event => {
              event.preventDefault()
              navigate(`/products/Birthday-Kids`)
            }}
          >
            <ImageTextOverlay />
          </Anchor>
          <ImageText>Birthday-Kids</ImageText>
        </TabItemBox>

        <TabItemBox key={"birthdaydebut"}>
          <Image src={BirthdayDebut} draggable={false} />
          <Anchor
            href={`${BASE_URL}/products/Birthday-Debut`}
            onClick={event => {
              event.preventDefault()
              navigate(`/products/Birthday-Debut`)
            }}
          >
            <ImageTextOverlay />
          </Anchor>
          <ImageText>Birthday-Debut</ImageText>
        </TabItemBox>

        <TabItemBox key={"wedding"}>
          <Image src={Wedding} />
          <Anchor
            href={`${BASE_URL}/products/Wedding`}
            onClick={event => {
              event.preventDefault()
              navigate(`/products/Wedding`)
            }}
          >
            <ImageTextOverlay />
          </Anchor>
          <ImageText>Wedding</ImageText>
        </TabItemBox>

        <TabItemBox key={"anniversary"}>
          <Image src={Anniversary} />
          <Anchor
            href={`${BASE_URL}/products/Anniversary`}
            onClick={event => {
              event.preventDefault()
              navigate(`/products/Anniversary`)
            }}
          >
            <ImageTextOverlay />
          </Anchor>
          <ImageText>Anniversary</ImageText>
        </TabItemBox>

        <TabItemBox key={"housewarming"}>
          <Image src={HouseWarming} />
          <Anchor
            href={`${BASE_URL}/products/House%20Warming`}
            onClick={event => {
              event.preventDefault()
              navigate(`/products/House%20Warming`)
            }}
          >
            <ImageTextOverlay />
          </Anchor>
          <ImageText>House Warming</ImageText>
        </TabItemBox>

        <TabItemBox>
          <Image src={Others} />
          <Anchor
            href={`${BASE_URL}/products/Others`}
            onClick={event => {
              event.preventDefault()
              navigate(`/products/Others`)
            }}
            key={"others"}
          >
            <ImageTextOverlay />
          </Anchor>
          <ImageText>Others</ImageText>
        </TabItemBox>
      </TabBox>
    </MainBox>
  )
}

export default EventWidget
